// extracted by mini-css-extract-plugin
module.exports = {"containerFluid":"Layout_containerFluid___rdUZ"};